import LoadingIndicator from 'components/shared/LoadingIndicator';
import MySchools from 'components/shared/ProfileV2/MySchools';
import UserInformation from 'components/shared/ProfileV2/UserInformation';
import React from 'react'
import { useParams } from 'react-router-dom'

function ProfileInformation() {
    const params = useParams() 
    return (
        <div>
            {!params?.slug && <LoadingIndicator />}
            {params?.slug === "user-information" && <UserInformation />}
            {params?.slug === "my-school" && <MySchools />}
        </div>
    )
}

export default ProfileInformation
